module.exports = __webpack_public_path__ + "static/media/ic_end_call.d4b89a23.svg";